module.exports = __webpack_public_path__ + "static/media/form3.9515c7eb.png";